import { http } from 'lib/client/http';

export function pingHoudini(params, isDesktop = true) {
    return http.get(isDesktop ? '/push' : '/r', { params });
}

export const HOUDINI_DATA_EXPIRE_TIME = 24 * 60 * 60 * 1000; // 24 hours in ms
